import { computed, Injectable, signal } from '@angular/core';
import { FeatureFlagApiService, FeatureFlags } from '@services/api/feature-flag.service';

export const FEATURE_FLAG_KEYS = {
  SUPPORT_RADIUS_FREE_GROUP: 'SUPPORT_RADIUS_FREE_GROUP',
  ADMOB_BANNER: 'ADMOB_BANNER',
} as const;

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly _flags = signal<FeatureFlags>({});
  private loadPromise?: Promise<void>;

  readonly flags = this._flags.asReadonly();
  readonly supportRadiusFreeGroup = computed(
    () => this._flags()[FEATURE_FLAG_KEYS.SUPPORT_RADIUS_FREE_GROUP] === true,
  );

  constructor(private featureFlagApi: FeatureFlagApiService) {}

  /** Fetches flags once and caches them; concurrent calls share the same request. */
  async load(): Promise<void> {
    if (this.loadPromise) return this.loadPromise;
    this.loadPromise = this.fetch();
    return this.loadPromise;
  }

  isEnabled(key: string): boolean {
    return this._flags()[key] === true;
  }

  private async fetch(): Promise<void> {
    try {
      const resp = await this.featureFlagApi.getAll();
      this._flags.set(resp.data ?? {});
    } catch {
      this._flags.set({});
      // Allow a retry on the next load() call after a failure.
      this.loadPromise = undefined;
    }
  }
}
